import _typeof from "@babel/runtime/helpers/esm/typeof";

/**
 * 微信内置浏览器
 * @param {func} callback 回调函数
 * @memberof module:wx
 */
function weiXinApply(callback) {
  if (_typeof(window.WeixinJSBridge) === 'object' && typeof window.WeixinJSBridge.invoke === 'function') {
    callback();
  } else {
    document.addEventListener('WeixinJSBridgeReady', callback, false);
  }
}

export { weiXinApply };